import { Route, Switch } from "react-router";
import MaintenanceRemindersForm from './MaintenanceRemindersForm';
import MaintenanceRemindersTable from "./MaintenanceRemindersTable";
import WriteRoute from "../../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route
      exact path="/reminders/maintenancereminders"
      component={MaintenanceRemindersTable}
    />
    <WriteRoute
      exact
      path="/reminders/maintenancereminders/addnew"
      component={MaintenanceRemindersForm}
      redirectTo="/reminders/maintenancereminders"
    />
  </Switch>
);
